import { useEffect, useRef, useState } from "react";

/** Remaining ms for a step that had already run `elapsedMs` (server clock) when loaded. */
export function useCountdown(seconds: number | null, elapsedMs: number, onZero?: () => void) {
  const total = seconds === null ? null : seconds * 1000;
  const [remaining, setRemaining] = useState<number | null>(
    total === null ? null : Math.max(0, total - elapsedMs),
  );
  const onZeroRef = useRef(onZero);
  useEffect(() => {
    onZeroRef.current = onZero;
  });

  useEffect(() => {
    if (total === null) return;
    const deadline = performance.now() + total - elapsedMs;
    let fired = false;
    const tick = () => {
      const left = Math.max(0, deadline - performance.now());
      setRemaining(left);
      if (left === 0 && !fired) {
        fired = true;
        onZeroRef.current?.();
      }
    };
    tick();
    const timer = window.setInterval(tick, 250);
    return () => window.clearInterval(timer);
  }, [total, elapsedMs]);

  return remaining;
}

export function formatClock(ms: number): string {
  const totalSeconds = Math.ceil(ms / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}
